import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckBox from "../checkBox/CheckBox";
import "./ProjectProcessAccordion.css";

function ProjectProcessAccordion({
  processesData,
  statusesData,
  onCheckboxChange,
  checkboxDisabled = false,
}) {
  const getCompletedCount = (subPhases) =>
    subPhases.filter((sp) => {
      const st = statusesData.find(
        (s) => s.process_property_status_id === sp.process_id,
      );
      return Boolean(st?.is_completed);
    }).length;

  /** Prefer ordered array from parent; avoid Object.entries key-order bugs on plain objects */
  const phases = (() => {
    if (!processesData) return [];
    if (Array.isArray(processesData)) {
      return processesData.map((p) => ({
        phaseName: p.phaseName ?? "Unknown",
        subPhases: Array.isArray(p.subPhases) ? p.subPhases : [],
      }));
    }
    if (typeof processesData === "object") {
      return Object.entries(processesData).map(([phaseName, subPhases]) => ({
        phaseName,
        subPhases: Array.isArray(subPhases) ? subPhases : [],
      }));
    }
    return [];
  })();

  return (
    <div className="project-process-accordion">
      {phases.map(({ phaseName, subPhases }) => {
        const items = subPhases;
        const total = items.length;
        const done = getCompletedCount(items);

        return (
          <Accordion
            key={phaseName}
            defaultExpanded={false}
            className="project-process-accordion__item"
            disableGutters
            elevation={0}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon className="project-process-accordion__expand-icon" />
              }
              className="project-process-accordion__summary"
            >
              <span className="project-process-accordion__phase">
                {phaseName}
              </span>
              <span className="project-process-accordion__meta">
                {done}/{total}
              </span>
            </AccordionSummary>
            <AccordionDetails className="project-process-accordion__details">
              <div className="project-process-accordion__checkbox-list">
                {items.map((subPhase) => {
                  const status = statusesData.find(
                    (s) => s.process_property_status_id === subPhase.process_id,
                  );
                  const isChecked = status ? status.is_completed : false;
                  return (
                    <CheckBox
                      key={`${phaseName}-${subPhase.process_id}`}
                      labelText={subPhase.name}
                      checked={isChecked}
                      disabled={checkboxDisabled}
                      onChange={(e) =>
                        onCheckboxChange(subPhase.process_id, e.target.checked)
                      }
                    />
                  );
                })}
              </div>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}

export default ProjectProcessAccordion;
